module.exports = __webpack_public_path__ + "static/media/facebook.700dba70.svg";